import { render, staticRenderFns } from "./sim_record.vue?vue&type=template&id=472a7fae&"
import script from "./sim_record.vue?vue&type=script&lang=js&"
export * from "./sim_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports